const collectCells = (cells, callback, parentNodes = []) => {
  cells.forEach((cell, index, all) => {
    const { items } = cell;
    const result = callback("CELL", cell, index, all, parentNodes);
    const nextParentNodes = [...parentNodes];
    const {
      id,
      meta: { type, name }
    } = cell;
    nextParentNodes.push({ id, type, name });
    if (result === true) return;

    if (items && items.length > 0)
      collectItems(items, callback, nextParentNodes);
  });
};
export const collectItems = (items, callback, parentNodes = []) => {
  items.forEach((item, index, all) => {
    const { rows } = item;
    const result = callback("ITEM", item, index, all, parentNodes);
    const nextParentNodes = [...parentNodes];
    const {
      id,
      meta: { type, name, kind }
    } = item;
    nextParentNodes.push({ id, type, name, kind });
    if (result === true) return;

    if (rows && rows.length > 0) {
      rows.forEach(row => {
        if (row.columns && row.columns.length > 0) {
          collectCells(row.columns, callback, nextParentNodes);
        }
      });
    }
  });
};

const collectColumns = (columns, callback, parentNodes = []) => {
  columns.forEach((column, index, all) => {
    const { items } = column;
    const result = callback("COLUMN", column, index, all, parentNodes);
    const nextParentNodes = [...parentNodes];
    const {
      id,
      meta: { type, name }
    } = column;
    nextParentNodes.push({ id, type, name });

    if (result === true) return;

    if (items && items.length > 0)
      collectItems(items, callback, nextParentNodes);
  });
};

const collectSections = (sections, callback, parentNodes = []) => {
  sections.forEach((section, index, all) => {
    const { contents } = section;
    const result = callback("SECTION", section, index, all);
    const nextParentNodes = [...parentNodes];
    const {
      id,
      meta: { type, name }
    } = section;
    nextParentNodes.push({ id, type, name });

    if (result === true) return;

    if (contents && contents.length > 0)
      collectColumns(contents, callback, nextParentNodes);
  });
};

export default collectSections;
